let configureStoreModule: any;

if (process.env.NODE_ENV === "production") {
  configureStoreModule = require("./configureStore.prod");
} else {
  configureStoreModule = require("./configureStore.dev");
}

export default configureStoreModule.default;
